import { Container, createTheme, useMediaQuery } from "@mui/material";
import React from "react";
import WhoWeAreContent from "./WhoWeAreContent";
import Box from "@mui/material/Box";

const WhoWeAre = () => {
  const largeScreen = createTheme({
    breakpoints: {
      values: {
        xxl: 1920,
      },
    },
  });
  const isLargeScreen = useMediaQuery(largeScreen.breakpoints.up("xxl"));
  return (
    <Box
      sx={{
        // backgroundImage: `url("${background}")`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        opacity: 0.85,
        width: "100%",
        position: "relative",
        // margin: "20px 0",
        height: "auto",
      }}
      style={{ backgroundColor: "#def2f2", padding: "50px 0" }}
    >
      <Container maxWidth={isLargeScreen ? "xl" : "lg"}>
        <WhoWeAreContent />
        
      </Container>
    </Box>
  );
};
export default WhoWeAre;
